import * as React from 'react'
import {
  convertToRegularBarcodeIfBatch,
  IBaseProduct,
  isBatchBarcode,
} from '@getgreenline/homi-shared'
import { Routes } from '../../../constants/Routes'
import { Icon, Alert, Row, Tooltip } from 'antd'
import { Link } from 'react-router'
import { AsyncSearchInputWrapper } from './AsyncSearchInputWrapper'
import { GrRegex } from '../../../utilities/helpers'

interface Props {
  size?: 'small' | 'default' | 'large'
  companyId: number
  productId: string | null
  className?: string
  wrapperClassName?: string
  disabled?: boolean
  barcode: string
  productChanged: boolean
  generateBarcode: () => void
  onChange: (barcode: string) => void
}

export class AsyncBarcodeSearchInput extends React.Component<Props> {
  filterProducts = (searchQuery: string, products: IBaseProduct[]): IBaseProduct[] => {
    return products.filter((product) => {
      if (!product.barcode) {
        return false
      }

      const escapedBarcode = GrRegex.regEscape(searchQuery)
      const regexBarcode = new RegExp(escapedBarcode, 'ig')
      return product.barcode.match(regexBarcode) !== null
    })
  }

  // Reference: gs1ca.org/cannabis-consumer/GS1-Barcoding-Guidelines-Consumer-Inner-Level-Cannabis-Products.pdf
  extractGTINFromBatchBarcode = () => {
    const { barcode } = this.props

    if (barcode) {
      const converted = convertToRegularBarcodeIfBatch(barcode)
      this.props.onChange(converted)
    }
  }

  get addOnAfter(): JSX.Element {
    if (!this.props.barcode) {
      return (
        <Tooltip title='Generate barcode'>
          <Icon type='barcode' onClick={this.props.generateBarcode} />
        </Tooltip>
      )
    }

    if (this.props.productId && !this.props.productChanged) {
      return (
        <Tooltip title='Print barcode label'>
          <Link
            target='_blank'
            to={Routes.PRINTING_CONFIG_VIEW(this.props.companyId, [
              { productId: this.props.productId, quantity: 1 },
            ])}
            style={{ color: 'currentColor' }}
          >
            <Icon type='printer' />
          </Link>
        </Tooltip>
      )
    } else {
      return (
        <Tooltip title='Please save first'>
          <Icon type='printer' />
        </Tooltip>
      )
    }
  }

  render() {
    const { size, className, wrapperClassName, productId, barcode, disabled, onChange } = this.props

    return (
      <>
        <AsyncSearchInputWrapper
          size={size}
          value={barcode}
          wrapperClassName={wrapperClassName}
          className={className}
          productId={productId}
          disabled={disabled}
          addonAfter={this.addOnAfter}
          filterProducts={this.filterProducts}
          onChange={onChange}
        />
        {isBatchBarcode(this.props.barcode) && (
          <Row type='flex' className='m-3'>
            <Alert
              type='warning'
              showIcon
              message='This looks like a lot-tracked barcode'
              description={
                <div>
                  <div>Would you like to convert this into a standard UPC barcode?</div>
                  <div>The POS will convert the scan results accordingly when a sale is made.</div>
                  <a onClick={this.extractGTINFromBatchBarcode}>Convert</a>
                </div>
              }
            />
          </Row>
        )}
      </>
    )
  }
}
